import React from "react";
import "./breadcrumb.scss";
import { Link } from "gatsby";
import { triggerCalculatorEvent } from "../../utils/garfieldHelpers";
import {
  EVENT_FIELDS,
  EVENT_NAMES,
  EVENT_SECTION_NAME,
} from "../../constants/garfieldEvents";

const Breadcrumb = ({ breadcrumbLinks, className }) => {
  const triggerEvent = name => {
    triggerCalculatorEvent(EVENT_NAMES.SECTION_CLICKED, {
      [EVENT_FIELDS.SECTION_NAME]:
        EVENT_SECTION_NAME.BREADCRUMB,
      [EVENT_FIELDS.ITEM_NAME]: name,
    });
  };

  return (
    <>
      <ul className={`breadcrumb ${className}`}>
        {breadcrumbLinks &&
          breadcrumbLinks.map((item, index) =>
            index !== breadcrumbLinks.length - 1 ? (
              <li className="item" key={index}>
                <Link
                  to={item.uri}
                  itemProp="url"
                  className="link"
                  onClick={() => triggerEvent(item.name)}
                >
                  {item.name}
                </Link>
              </li>
            ) : (
              <li className="item" key={index}>
                <span className="link">{item.name}</span>
              </li>
            )
          )}
      </ul>
    </>
  );
};

export default Breadcrumb;
